var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.486 14.857c.284 0 .514.256.514.572 0 .306-.217.556-.49.57l-.024.001H.514C.23 16 0 15.744 0 15.429c0-.307.217-.557.49-.571H15.486zm-13.2-4.571v2.971H0v-2.971h2.286zm6.857-6.857v9.828H6.857V3.43h2.286zM16 10.286v2.971h-2.286v-2.971H16zM5.714 8.914v4.343H3.43V8.914h2.285zm6.857 0v4.343h-2.285V8.914h2.285zM7.975 0C10 0 11.44 1.752 12.14 5.053c.267 1.218 1.528 2.103 3 2.105h.36c.276 0 .5.531.5.764 0 .232-.224.764-.5.764h-.31c-1.965.004-3.765-1.18-4.114-2.809C10.696 4.24 9.945 1.503 8 1.503s-2.73 2.74-3.076 4.374C4.571 7.503 2.772 8.682.81 8.677H.5c-.276 0-.5-.531-.5-.764 0-.232.224-.764.5-.764h.3c1.468 0 2.728-.881 3-2.096C4.505 1.735 5.95 0 7.975 0z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.000f2fc6a447e25587b2b5236d90f904.svg";
export { ForwardRef as ReactComponent };